import { Pressable, StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { colors, spacing } from '@pletly/ui';
import DeleteIcon from '%assets/icons/delete.svg';
import { FileLink } from '%components/Files/FileLink';
import { FileName } from '%components/Files/FileName';

interface Props {
	name: string;
	url?: string | null;
	onRemove?: () => void;
}

export const File = ({ name, url, onRemove }: Props) => {
	const { t } = useTranslation();

	return (
		<View style={styles.file}>
			{url ? <FileLink url={url} filename={name} /> : <FileName name={name} />}

			{onRemove && (
				<Pressable
					onPress={onRemove}
					accessibilityRole="button"
					accessibilityLabel={t('post.delete-file')}
				>
					<DeleteIcon scale={0.8} />
				</Pressable>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	file: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginVertical: spacing(),
		borderWidth: 1,
		borderRadius: spacing(0.5),
		borderColor: colors.background200,
		padding: spacing(1),
	},
});
